import { Button, Checkbox, FormControlLabel } from "@mui/material";
import { Link } from "react-router-dom";
import { govHubSubPath } from "../../utils/utils";
import { useState } from "react";
import PropTypes from "prop-types";

const BulkTaxPaymentsCheckBox = ({ content }) => {
    const [checked, setChecked] = useState(false);

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    return (
        content && (
            <>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checked}
                            onChange={handleChange}
                            inputProps={{ "aria-label": "controlled" }}
                            sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                        />
                    }
                    label="I have Read and Accept the Terms and Conditions described above."
                    sx={{ "& .MuiTypography-root": { fontWeight: "bold", fontSize: "large" } }}
                />
                <div className="text-center p-3">
                    <Button
                        component={Link}
                        to={`/${govHubSubPath}/property-tax/upload`}
                        variant="contained"
                        disabled={!checked}
                        sx={{ px: 3 }}
                    >
                        Continue
                    </Button>
                </div>
            </>
        )
    );
};

BulkTaxPaymentsCheckBox.propTypes = {
    content: PropTypes.string.isRequired
};

export default BulkTaxPaymentsCheckBox;
